import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const PopoverSpotsBigClient = ({
    content,
    children,
    isSelected,
    onCheckboxToggle,
    onClick,
    columnsPerRow = 5,
}) => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const popoverRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popoverRef.current && !popoverRef.current.contains(event.target)) {
                setIsVisible(false);
            }
        };

        if (isVisible) {
            document.addEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [isVisible]);

    const handleClick = () => {
        setIsVisible((prev) => !prev);
        onClick && onClick();
    };

    const handleCheckboxChange = (index) => {
        onCheckboxToggle(index);
    };

    return (
        <div style={{ position: 'relative' }} ref={popoverRef}>
            <div onClick={handleClick}>{children}</div>
            {isVisible && (
                <div
                    style={{
                        position: 'absolute',
                        bottom: '120%',
                        left: '0%',
                        transform: 'translateX(-70%)',
                        width: 'fit-content',
                        minWidth: '300px',
                        maxWidth: '1200px',
                        backgroundColor: '#fff',
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                        padding: '15px',
                        borderRadius: '15px',
                        zIndex: 999,
                        boxSizing: 'border-box',
                    }}
                >
                    <ul
                        style={{
                            listStyleType: 'none',
                            padding: 0,
                            margin: 0,
                            display: 'grid',
                            gridTemplateRows: 'repeat(6, auto)',
                            gridAutoFlow: 'column',
                            gridAutoColumns: '200px',
                            gap: '8px',
                        }}
                    >
                        {content.map((item, index) => (
                            <li
                                key={index}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <span className="box-checkbox">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={item.name}
                                        name={item.name}
                                        checked={item.visible}
                                        onChange={() => handleCheckboxChange(index)}
                                    />
                                </span>
                                <label
                                    style={{ marginTop: '0px', marginLeft: '5px', cursor: 'pointer' }}
                                    htmlFor={item.name}
                                >
                                    {t(item.label)}
                                </label>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default PopoverSpotsBigClient;